import { useEffect, useState } from "react";

import { timeRangeOpts } from "@doitintl/clouddiagrams-frontend/app/context/Costs";

import { useApiContext } from "../../../api/context";
import { useCustomerContext } from "../../../Context/CustomerContext";
import { useIsFeatureEntitled } from "../../../Context/TierProvider";
import DashboardHead from "./DashboardHead";
import DashboardList, { getDiagramList, getDiagramsTrending } from "./DashboardList";
import DefaultPage from "./DefaultPage";
import UpsellPage from "./UpsellPage";

interface DiagramItem {
  _id: string;
  ss_id: string;
  name?: string;
  account_name?: string;
  account_type?: string;
  changes?: Array<{
    type: string;
    count: number;
    service: string;
  }>;
}

const CloudDiagramsDashboard = () => {
  const isEntitled = useIsFeatureEntitled("governance:cloud-diagrams");

  const [searchQuery, setSearchQuery] = useState("");
  const [diagramList, setDiagramList] = useState<null | DiagramItem[]>(null);
  const [isCostTrendingLoading, setIsCostTrendingLoading] = useState<boolean>(false);
  const [timeRange, setTimeRange] = useState<number>(timeRangeOpts[1].value);
  const [costDiagramsTrendingObject, setCostDiagramsTrendingObject] = useState({});

  const api = useApiContext();
  const { customer } = useCustomerContext();

  useEffect(() => {
    if (!isEntitled) setDiagramList([]);
    else {
      getDiagramList(api, customer, setDiagramList);
      getDiagramsTrending(api, customer, timeRange, setIsCostTrendingLoading, setCostDiagramsTrendingObject);
    }
  }, [api, customer, isEntitled, timeRange]);

  return !diagramList ? null : !isEntitled ? (
    <UpsellPage />
  ) : diagramList.length > 0 ? (
    <div data-cy="clouddiagrams-dashboard-container">
      <DashboardHead {...{ onSearch: setSearchQuery, isCostTrendingLoading, timeRange, setTimeRange }} />
      <DashboardList
        {...{
          searchQuery,
          diagramList,
          setDiagramList,
          timeRange,
          isCostTrendingLoading,
          costDiagramsTrendingObject,
        }}
      />
    </div>
  ) : (
    <DefaultPage />
  );
};

export default CloudDiagramsDashboard;
